const host = process.env.REACT_APP_API_ENDPOINT
export const get_auth_data = host + "/auth/";

export const add_project = host + "/auth/add";

export const get_doc = host + "/project";
export const terms = "https://ghostengines.io/tandc";
export const privacy = "https://ghostengines.io/privacy-policy";